import React, { Fragment, useState } from 'react';
import {
  ModalBody,
  ModalFooter,
  Modal,
  ModalHeader,
  Button,
  Input,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Row,
} from 'reactstrap';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
import { useDropzone } from 'react-dropzone';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  AxiosPublicAPI,
  getGroupID,
} from '../../../../../../helpers/AxiosAPI';
import { Upload_Email_Attachment } from '../../../../../../constants/APIs';
import moment from 'moment';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};
const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];

const styles = `
      .ql-toolbar {  
        border: 1px solid #ccc !important;            
         border-radius: 0px!important;  
         background:white;       
      }

      .ql-container{
        border: 1px solid #ccc !important; 
        border-radius: 0px!important;   
        background:white;      
      }
      
      .dropzone {
        min-height: 40px !important;
        cursor:pointer;
    }
  `;

const NewEmail = ({ visible, toggle, emailIntegration, propertyId }) => {
  const [attachementList, setAttachmentList] = useState([]);
  const fileObj = [];
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      acceptedFiles.map((file) => {
        if (!file.name.includes('exe')) {
          fileObj.push({
            img: Object.assign(file, {
              preview: URL.createObjectURL(file),
            }),
          });
        }
      });
      setAttachmentList([...attachementList, ...fileObj]);
    },
  });
  const [emailData, setEmailData] = useState({
    from: emailIntegration?.channelDetails?.forwardingEmail,
    to: '',
    subject: '',
    text: '',
    attachments: [],
  });

  const handleChange = (e) =>
    setEmailData({ ...emailData, [e.target.name]: e.target.value });

  const handleMessage = (source, e) => {
    if (source === 'user') setEmailData({ ...emailData, text: e });
  };

  const handleRemove = (index) => {
    let lst = [...attachementList];
    lst = lst.filter((f, i) => i !== index);
    setAttachmentList(lst);
    // handleFiles(lst);
  };

  const sendMessage = async (draft = false) => {
    let attachments = [];
    if (attachementList !== undefined && attachementList.length > 0) {
      const result = await handleAttachmentUpload('');
      if (result?.data && result.data.length > 0) {
        result.data.map((m) => {
          attachments.push({
            shortName: m.shortName,
            fileName: m.fileName,
            contentType: m.contentType,
          });
        });
      }
    }
    let email = '';
    if (emailIntegration !== undefined) {
      email = emailIntegration?.channelDetails?.forwardingEmail;
    }
    let body = {
      GroupId: getGroupID(),
      IntegrationId: emailIntegration?.id,
      Recipients: emailData.to,
      Attachments: attachments,
      PropertyId: propertyId,
      From: email,
      SentUtc: moment(),
      Subject: emailData?.subject,
      Source: 'Bot',
      asdraft: false,
      EmailContent: emailData?.text,
      Content: {
        type: 'message-email',
        messages: [emailData?.text],
      },
      BotMessageId: '',
    };
    let url = `${process.env.REACT_APP_CHAT_API}/email-create`;
    AxiosPublicAPI({
      method: 'post',
      url: url,
      data: body,
    }).then((res) => {
      toggle();
    });
  };

  const handleAttachmentUpload = async (sessionId) => {
    const data = new FormData();
    attachementList.forEach((file) => {
      data.append('files', file.img);
    });
    data.append('sessionId', sessionId);
    data.append('creator', 'dashboard');
    return await AxiosAPI({
      method: 'post',
      url: `${Upload_Email_Attachment}`,
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Email</ModalHeader>
        <ModalBody>
          <style>{styles}</style>
          <Row className="my-2">
            <Colxx md="12" className="mb-3">
              <InputGroup>
                <InputGroupAddon>
                  <InputGroupText>To</InputGroupText>
                </InputGroupAddon>
                <Input
                  type="text"
                  name="to"
                  id="to"
                  value={emailData?.to}
                  onChange={handleChange}
                />
              </InputGroup>
            </Colxx>
            <Colxx md="12" className="mb-3">
              <InputGroup>
                <InputGroupAddon>
                  <InputGroupText>Subject</InputGroupText>
                </InputGroupAddon>
                <Input
                  type="text"
                  name="subject"
                  id="subject"
                  value={emailData?.subject}
                  onChange={handleChange}
                />
              </InputGroup>
            </Colxx>
            <Colxx md="12" className="mb-3">
              <ReactQuill
                theme="snow"
                style={{ height: '250px' }}
                value={emailData?.text}
                onChange={(content, delta, source) =>
                  handleMessage(source, content)
                }
                modules={quillModules}
                formats={quillFormats}
                placeholder="Reply"
                name="message"
              />
            </Colxx>
            <Colxx md="12" className="mb-2" style={{ marginTop: '1.95rem' }}>
              <h5>Attachments</h5>
            </Colxx>
            <Colxx md="12" className="mb-2">
              <div {...getRootProps({ className: 'dropzone' })}>
                <input {...getInputProps()} />
                <div class="dz-default dz-message">
                  <span>
                    Drop files here to upload, or click to select files. Recommended upload limit of 10mb per file. Supported formats: JPEG, PNG, GIF, WEBP, SVG.
                  </span>
                </div>
              </div>
            </Colxx>
            <Colxx md="12" className="mb-2">
              {attachementList.map((file, index) => (
                <Row className="mx-0">
                  <Colxx
                    md="10"
                    style={{ border: '1px solid', padding: '5px 10px' }}
                  >
                    <div key={index}>
                      <div className="row mx-0">
                        <span data-dz-name>{file.img.name}</span>
                        <div
                          className="text-primary text-extra-small"
                          data-dz-size
                        >
                          {file.img.size}
                        </div>
                      </div>
                    </div>
                  </Colxx>
                  <Colxx md="2">
                    <Button
                      color="danger"
                      outline
                      size="xs"
                      onClick={() => handleRemove(index)}
                    >
                      X
                    </Button>
                  </Colxx>
                </Row>
              ))}
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" size="xs" outline onClick={sendMessage}>
            Send
          </Button>
          <Button color="secondary" size="xs" outline onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default NewEmail;
